/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Mock_Group_ProductsInputs */

const tr_landing_shortcuts_mock_group_products = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÜRÜNLER`)
};

const en_landing_shortcuts_mock_group_products = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRODUCTS`)
};

const de_landing_shortcuts_mock_group_products = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRODUKTE`)
};

const ru_landing_shortcuts_mock_group_products = /** @type {(inputs: Landing_Shortcuts_Mock_Group_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТОВАРЫ`)
};

/**
* | output |
* | --- |
* | "PRODUCTS" |
*
* @param {Landing_Shortcuts_Mock_Group_ProductsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_mock_group_products = /** @type {((inputs?: Landing_Shortcuts_Mock_Group_ProductsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Mock_Group_ProductsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_mock_group_products(inputs)
	if (locale === "de") return de_landing_shortcuts_mock_group_products(inputs)
	if (locale === "ru") return ru_landing_shortcuts_mock_group_products(inputs)
	return tr_landing_shortcuts_mock_group_products(inputs)
});